<!--
 * @Author: 黄昱森
 * @LastEditors: 黄昱森
 * @Description:
-->
<template>
  <component :is="comName" :hasIndex="hasIndex" :value="value" :steps="steps">
    <template v-for="(step, index) in steps" :slot="`desc${index + 1}`">
      <slot :name="`desc${index + 1}`" />
    </template>
    <slot />
  </component>
</template>
<script>
import DefaultSteps from './default-steps.vue';
import RoundSteps from './round-steps.vue';
import HorizontalSteps from './horizontal-steps.vue';
import TagsSteps from './tags-steps.vue';
import VerticalSteps from './vertical-steps.vue';
export default {
  name: 'LcSteps',
  components: { DefaultSteps, RoundSteps, HorizontalSteps, TagsSteps, VerticalSteps },
  props: {
    headDirection: {
      type: String,
      default: 'horizontal'
    },
    headStyle: {
      type: String,
      default: 'style1'
    },
    hasIndex: {
      type: Boolean,
      default: true
    },
    value: {
      type: Number,
      default: 0
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (this.$el) {
          this.changeClass(val);
        } else {
          this.$nextTick(() => {
            this.changeClass(val);
          });
        }
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    steps() {
      return this.$slots.default;
    },
    comName() {
      const components = {
        style1: DefaultSteps,
        style2: RoundSteps,
        style3: HorizontalSteps,
        style4: TagsSteps
      };
      return this.headStyle == 'style1' && this.headDirection == 'vertical'
        ? VerticalSteps
        : components[this.headStyle];
    }
  },
  created() {
    // preset
  },
  mounted() {
    // preset
  },
  methods: {
    changeClass(val) {
      this.$el.querySelector('.lc-steps__content-show')?.classList.remove('lc-steps__content-show');
      this.$el.querySelector(`.lc-steps__content:nth-child(${val + 1})`)?.classList.add('lc-steps__content-show');
    }
  }
};
</script>
<style lang="scss">
.lc-steps__content {
  display: none;
}
.lc-steps__content-show {
  display: block;
}
.lc-steps__container {
  height: 100%;
  width: 100%;
}
</style>
